export const SLICING_AVAILABLE_LIST_REQUEST = "SLICING_AVAILABLE_LIST_REQUEST";
export const SLICING_AVAILABLE_LIST_SUCCESS = "SLICING_AVAILABLE_LIST_SUCCESS";
export const SLICING_AVAILABLE_LIST_FAILED = "SLICING_AVAILABLE_LIST_FAILED";
